import React, { useEffect, useState } from 'react';

import itemTypeService from '../../service/itemType.service';
import { DataGridIdentifiers, DatagridPremiumUi } from '../Interface';
import { dataGridPremiumColumns } from '../../utils/helper';

const normalizeRows = (data) => {
  return Array.isArray(data) ? data : data?.rows ?? [];
};

const ItemTypeReports = ({ refetch, values, viewField, operatorsDisabled, rowSelection }) => {
  const { refetchTable, setRefetchTable } = refetch;
  const { setSelectedValues } = values;
  const { rowSelectionModel, setRowSelectionModel } = rowSelection;
  const [rows, setRows] = useState([]);

  useEffect(() => {
    itemTypeService.getData().then((data) => {
      setRows(normalizeRows(data));
      setRefetchTable(false);
    });
  }, [refetchTable, setRefetchTable]);

  useEffect(() => {
    if (operatorsDisabled) {
      setRowSelectionModel([]);
    }
  }, [operatorsDisabled, setRowSelectionModel]);

  const getList = async () => {
    const data = await itemTypeService.getData();
    const normalizedRows = normalizeRows(data);
    setRows(normalizedRows);
    return {
      rows: normalizedRows,
      rowCount: normalizedRows.length,
    };
  };

  const columns = dataGridPremiumColumns([
    {
      field: 'name',
      headerName: 'Név',
      type: 'string',
      flex: 1,
    },
    {
      field: 'externalCode',
      headerName: 'Külső azonosító',
      type: 'string',
      flex: 1,
    },
    {
      field: 'active',
      headerName: 'Aktív',
      type: 'boolean',
      flex: 0.5,
    },
  ]);

  return (
    <DatagridPremiumUi
      datagridIdentifier={DataGridIdentifiers.ItemType}
      datagridInitialState={{
        filter: { filterModel: { items: [], logicOperator: 'and' } },
        sorting: {
          sortModel: [{ field: 'name', sort: 'asc' }],
        },
        pagination: {
          paginationModel: {
            pageSize: 25,
            page: 0,
          },
        },
        density: 'compact',
      }}
      dataLoader={getList}
      rows={rows}
      rowCount={rows.length}
      columns={columns}
      getRowId={(row) => row.id}
      refetch={{ refetchTable, setRefetchTable }}
      paginationAndfilterMode="client"
      onRowClick={async (rowData) => {
        if (!viewField) return;
        const data = await itemTypeService.getItem(rowData.row.id);
        setSelectedValues(data);
      }}
      onRowSelectionModelChange={(newRowSelectionModel) => {
        setRowSelectionModel(newRowSelectionModel);
      }}
      rowSelectionModel={rowSelectionModel}
      disableRowSelectionOnClick={!viewField}
    />
  );
};

export default ItemTypeReports;
